<template>
  <div style="width:80%;position: relative;" :key="componentKey">
    <div class="itinerary-right-list" contenteditable="true" ref="listDom" :id="`pdf-details${pdfIndex}`" v-for="item,pdfIndex in store.state.dataTickets" :key="pdfIndex" style="position: absolute;z-index: 1;top:0;right:0;">
    <div class="list-header">
      <img :src="store.state.images.IATA_logo" class="IATA-logo" />
    </div>
    <hr />
    <div class="list-content">
      <div class="list-content-tltle">
        {{
          store.state.seledLetter == "chen" ? "电子客票行程单 ITINERARY" : ""
        }}
      </div>
      <div class="content-plane-msg">
        <div class="plane-msg-row">
          <div class="plane-msg-item">
            <div class="plane-name">航空公司记录编号 AIRLINE PNR:</div>
            <div
              class="plane-text"
              style="width: 40%"
            > {{store.state.resolveData.AirlineBigCode}} </div>
          </div>
          <div class="plane-msg-item">
            <div class="plane-name">订座记录编号 1E PNR:</div>
            <div
              class="plane-text"
              style="width: 40%"
            > {{store.state.resolveData.Pnr}} </div>
          </div>
        </div>
        <div class="plane-msg-row">
          <div class="plane-msg-item1" v-if="store.state.seledPDF=='many'">
            <div class="plane-name">旅客姓名 NAME:</div>
            <!-- <div  style="width:70%"> -->
              <div
                class="auto-box"
                type="text"
                v-for="(item, index) in store.state.dataTickets"
                :key="index"
                style="width: 70%"
              > {{item.PersonName ? item.PersonName+';':''}} </div>
            <!-- </div> -->
          </div>
          <div class="plane-msg-item1" v-if="store.state.seledPDF=='one'">
            <div class="plane-name">旅客姓名 NAME:</div>
              <div
                class="auto-box"
                type="text"
                style="width: 70%"
                id="PersonNameText"
              > {{store.state.dataTickets[pdfIndex].PersonName ? store.state.dataTickets[pdfIndex].PersonName+';':''}} </div>
          </div>
          <div class="plane-msg-item1" v-if="store.state.seledPDF=='many'">
            <div class="plane-name">票号 ETKT NBR:</div>
            <!-- <div  style="width:70%"> -->
              <div
                class="auto-box"
                v-for="(item, index) in store.state.resolveData.Tickets.length > 0?store.state.resolveData.Tickets:[{PersonName:''}]"
                :key="index"
                style="width: 70%"
              >{{item.TicketNo ? item.TicketNo+';':''}}</div>
            <!-- </div> -->
          </div>
          <div class="plane-msg-item1" v-if="store.state.seledPDF=='one'">
            <div class="plane-name">票号 ETKT NBR:</div>
              <div
                class="auto-box"
                style="width: 70%"
                id="TicketNoText"
              >{{store.state.dataTickets[pdfIndex].TicketNo ? store.state.dataTickets[pdfIndex].TicketNo+';':''}}</div>
          </div>
        </div>
        <div class="plane-msg-row">
          <div class="plane-msg-item1" v-if="store.state.seledPDF=='many'">
            <div class="plane-name">身份识别代码 ID NUMBER:</div>
            <!-- <div  style="width: 70%;"> -->
              <div
                class="auto-box"
                v-for="(item, index) in store.state.resolveData.Tickets.length > 0?store.state.resolveData.Tickets:[{PersonName:''}]"
                :key="index"
                style="width: 40%"
              > {{item.Certificate ? item.Certificate+';':''}} </div>

            <!-- </div> -->
          </div>
          <div class="plane-msg-item1" v-if="store.state.seledPDF=='one'">
            <div class="plane-name">身份识别代码 ID NUMBER:</div>
              <div
                class="auto-box"
                style="width: 40%"
                id="CertificateText"
              > {{store.state.dataTickets[pdfIndex].Certificate ? store.state.dataTickets[pdfIndex].Certificate+';':''}} </div>
          </div>
          <div class="plane-msg-item">
            <div class="plane-name">联票 CONJ NBR:</div>
            <div class="plane-text" />
          </div>
        </div>
        <div class="plane-msg-row">
          <div class="plane-msg-item1">
            <div class="plane-name">出票航空公司 ISSUING AIRLINE:</div>
            <div
              class="plane-text"
              style="width: 45%; height: auto"
            >
              {{ store.state.resolveData.Airline }}
            </div>
          </div>
          <div class="plane-msg-item">
            <div class="plane-name">出票时间 DATE OF ISSUE:</div>
            <div
              class="plane-text"
              style="width: 45%"
            > {{store.state.resolveData.DateOfIssue}} </div>
          </div>
        </div>
        <div class="plane-msg-row">
          <div class="plane-msg-item">
            <div class="plane-name">出票代理人 ISSUING AGENT:</div>
            <div
              class="plane-text"
              style="width: 45%"
            >{{store.state.adminName}}</div>
          </div>
          <div class="plane-msg-item">
            <div class="plane-name">航协代码 IATA CODE:</div>
            <div
              class="plane-text"
            > {{store.state.resolveData.AirNo}} </div>
          </div>
        </div>
        <div class="plane-msg-row">
          <div class="plane-msg-item1" style="width: 100%;">
            <div class="plane-name">代理人地址 AGENCY ADDRESS:</div>
            <div
              class="plane-text"
            >
              {{ address }}
            </div>
          </div>
        </div>
        <div class="plane-msg-row">
          <div class="plane-msg-item">
            <div class="plane-name">电话 TEL:</div>
            <div class="plane-text">{{store.state.phone}}</div>
          </div>
          <div class="plane-msg-item">
            <div class="plane-name">传真 FAX:</div>
            <DIV class="plane-text">{{store.state.fax}}</div>
          </div>
        </div>
      </div>
      <hr />
      <div class="plane-msg-list">
        <table class="flight-table">
          <thead>
            <tr>
              <th v-html="'起飞机场\rORIGIN'"></th>
              <th v-html="'到达机场\rDES'"></th>
              <th v-html="'航班\rFLIGHT'"></th>
              <th v-html="'舱位\rCLASS'"></th>
              <th v-html="'日期\rDATE'"></th>
              <th v-html="'起飞\rTIME'"></th>
              <th v-html="'到达\rPERIOD'"></th>
              <th v-html="'状态\rSTATUS'"></th>
              <th v-html="'行李\rALLOW'"></th>
              <th v-html="'起飞航站楼\rTERMINAL Takeoff'"></th>
              <th v-html="'到达航站楼\rTERMINAL Arrival'"></th>
            </tr>
          </thead>
          <tbody
            class="flight-tbody"
            v-if="
              store.state.resolveData.Flights &&
              store.state.resolveData.Flights.length > 0
            "
          >
            <tr
              v-for="(item, index) in store.state.resolveData.Flights"
              :key="index"
            >
              <td v-html="item.Departure"></td>
              <td v-html="item.Destination"></td>
              <td>{{ item.Flight }}</td>
              <td>{{ item.Position }}</td>
              <td>{{item.FlightDate}}</td>
              <td>{{ item.DepartureTime.slice(0, 2) + ":" + item.DepartureTime.slice(2, 4) }}</td>
              <td>
                {{ item.DestinationTime.slice(0, 2) + ":" + item.DestinationTime.slice(2, 4) +(item.ModifyDate == 0 ? '':'+' + item.ModifyDate)}}
              </td>
              <td>{{ item.FlightStatus }}</td>
              <td>
                {{ item.Luggage == "0" ? "" : item.Luggage }}
              </td>
              <td>
                {{ item.DepartureTerminal }}
              </td>
              <td>
                {{ item.DestinationTerminal }}
              </td>
            </tr>
            <!-- 可以添加更多的航班信息行 -->
          </tbody>
        </table>
      </div>
      <hr />
      <div class="price-box">
        <div class="price-item">
          <span class="price-item-name">机票款 FARE:</span>
          <div class="price-item-input"> {{airTicketPrice}} </div>
        </div>
        <div class="price-item">
          <span class="price-item-name">税款 TAX:</span>
          <div class="price-item-input">{{taxes}}</div>
        </div>
        <div class="price-item">
          <span class="price-item-name">总额 TOTAL:</span>
          <div class="price-item-input"> {{allPrice}} </div>
        </div>
      </div>
      <div class="hint-box">
        <div class="hint-title" v-html="'须知 \rNotice:'"></div>
        <div
          class="hint-item"
          v-html="
            '· 请您再次核对航班信息；\r Please check the flight information again；'
          "
        ></div>
        <div
          class="hint-item"
          v-html="
            '· 联程客票须按顺序使用，不得跳段使用；\r The connecting ticket shall be used in sequence and shall not be used in skip section;'
          "
        ></div>
        <div
          class="hint-item"
          v-html="
            '· 请确认您的护照有效期至少在半年以上；\r Please confirm that your passport is valid for at least half a year;'
          "
        ></div>
        <div
          class="hint-item"
          v-html="
            '· 国际航班请您至少在航班起飞前3小时到达机场，并且办理乘机手续；\r For international flights, please arrive at the airport at least 3 hours before departure and check in;'
          "
        ></div>
        <div
          class="hint-item"
          v-html="
            '· 请您在航班起飞前72小时再次确认您的行程。\r Please reconfirm your itinerary 72 hours before departure.'
          "
        ></div>
      </div>
    </div>
  </div>
  </div>
</template>


<script setup>
import { nextTick, ref } from "vue";
import htmlPdf from "@/utils/pdf.js";
import { useStore } from "vuex";

const store = useStore();
const address = ref('')
const airTicketPrice = ref(0)
const taxes = ref(0)
const listDom= ref(null)
const allPrice = ref(0)
const componentKey = ref(0)

function judgmentDate(text){
  let moonList = [
    {
      name:'JAN',
      num:'01'
    },
    {
      name:'FEB',
      num:'02'
    },
    {
      name:'MAR',
      num:'03'
    },
    {
      name:'APR',
      num:'04'
    },{
      name:'MAY',
      num:'05'
    },
    {
      name:'JUN',
      num:'06'
    },
    {
      name:'JUL',
      num:'07'
    },
    {
      name:'AUG',
      num:'08'
    },
    {
      name:'SEP',
      num:'09'
    },
    {
      name:'OCT',
      num:'10'
    },
    {
      name:'NOV',
      num:'11'
    },
    {
      name:'DEC',
      num:'12'
    }]
    let content = ''
  moonList.forEach((element)=>{
    if(element.name.toUpperCase() == text.toUpperCase()){
      content = element.num
    }
  })
  return content
}

function childPDF() {
  let TypeName = "电子行程单";
  if(store.state.seledPDF=='many'){
    htmlPdf(TypeName, document.querySelector(`#pdf-details0`));
  }else {
    store.state.dataTickets = store.state.resolveData.Tickets
    nextTick(()=>{
        listDom.value.forEach((element1,index)=>{
        element1.innerHTML = listDom.value[0].innerHTML
        element1.querySelector('#PersonNameText').innerText = store.state.dataTickets[index].PersonName
        element1.querySelector('#TicketNoText').innerText = !store.state.dataTickets[index].TicketNo ? "" : store.state.dataTickets[index].TicketNo
        element1.querySelector('#CertificateText').innerText = store.state.dataTickets[index].Certificate
      })
      })

      nextTick(()=>{
      store.state.dataTickets.forEach((element,index)=>{
        htmlPdf(element.PersonName +TypeName, document.querySelector(`#pdf-details${index}`));
      })
    })
    nextTick(()=>{
      componentKey.value = new Date()
      })
  }
}

defineExpose({
  childPDF,
});
</script>


<style scoped>
.itinerary-right-list {
  width: 100%;
  padding: 20px 0;
}

.itinerary-right-list:focus {
  border: 0;
  outline: none;
}

#pdf-details0{
  position: relative !important;
  z-index: 1000 !important;
  background-color: #fff;
  /* right: 32px !important; */
}

.list-header {
  width: 100%;
}

.IATA-logo {
  width: 84px;
  height: 59px;
}

.list-content {
  width: 100%;
  color: #000;
}

.list-content-tltle {
  width: 100%;
  text-align: center;
  font-size: 20px;
  margin-top: 16px;
  font-weight: 600;
}

.list-content-en-tltle {
  width: 100%;
  font-size: 18px;
  margin-top: 8px;
  text-align: center;
  font-weight: 600;
}

.content-plane-msg {
  width: 100%;
  margin-top: 40px;
}

.plane-msg-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 8px;
}

.plane-msg-item {
  width: 45%;
  display: flex;
  flex-flow: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 14px;
}

.plane-msg-item1 {
  width: 45%;
  display: flex;
  flex-flow: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 14px;
}

.plane-name {
  text-align: start;
  font-size: 12px;
}

.plane-text {
  width: 65%;
  margin-left: 4px;
  border: 0;
  min-height: 22px;
  text-align: start;
  font-size: 12px;
}

.auto-box {
  width: 70%;
  min-height: 22px;
  margin-left: 4px;
  border: 0;
  text-align: start;
  font-size: 12px;
}

/* 飞机 */

.plane-msg-list {
  width: 100%;
  /* margin-top: .32rem; */
  /* background-color: #f2f2f2; */
  /* overflow-y: scroll; */
}

.flight-table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;
}

.flight-table th,
.flight-table td {
  /* border: 1px solid #ddd; */
  padding: 8px;
  text-align: left;
  white-space: pre-line;
}

/* .flight-table th {
  background-color: #f2f2f2;
}

.flight-table tr:hover {
  background-color: #f7f7f7;
}


.flight-table tr th:hover {
  background-color: #f9f9f9;
}

.flight-tbody tr td:hover {
  background-color: #fff;
} */

.price-box {
  width: 100%;
  display: flex;
  font-size: 14px;
  margin-top: 10px;
  justify-content: space-between;
}

.price-item {
  width: 33%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.price-item-name {
}

.price-item-input {
  border: 0;
  height: 21px;
  margin-left: 4px;
}

.hint-box {
  width: 100%;
  margin-top: 16px;
}

.hint-title {
  width: 100%;
  text-align: start;
  white-space: pre-line;
  font-size: 14px;
  font-weight: 700;
}

.hint-item {
  width: 100%;
  margin-top: 8px;
  white-space: pre-line;
  font-size: 14px;
  text-align: start;
}

.put-xing-cheng {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  position: fixed;
  bottom: 0;
  align-items: center;
  color: #888;
  padding: 8px 32px;
  background-color: #f7f7f7;
}

.generate-btn {
  background: #e27575;
  border: none;
  padding: 10px 25px 10px 25px;
  color: #fff;
  box-shadow: 1px 1px 5px #b6b6b6;
  border-radius: 3px;
  text-shadow: 1px 1px 1px #9e3f3f;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  margin-left: 12px;
  text-align: center;
}

input:focus {
  border: 1px solid #000;
}

.hint-text {
  margin-left: 16px;
  color: red;
  font-weight: 700;
  font-size: 14px;
}
</style>